import { Named } from '../base/named';
import { Metamodel } from '../base/model';
import { IModel, IAttribute } from 'shell-models-lib';

@Metamodel.model({
    name: 'delta-sink-settings',
    display: []
})
export class DeltaSinkSettings extends Named {
    public static readonly MODEL: IModel;
    public static readonly VACUUM: IAttribute;
    public static readonly AUTO_COMPACT: IAttribute;
    public static readonly OPTIMIZED_WRITE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Vacuum,
        association: 'VACUUM',
        templatable: true,
        accepts: ['Int'],
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public vacuum?: number;

    @Metamodel.attribute({
        display: stringResources.AutoCompact,
        association: 'AUTO_COMPACT',
        templatable: true,
        accepts: ['Bool']
    })
    public autoCompact?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.OptimizedWrite,
        association: 'OPTIMIZED_WRITE',
        templatable: true,
        accepts: ['Bool']
    })
    public optimizedWrite?: boolean = false;
}
